// import appConfig from "./appConfig";

const baseConfig = {
  schema: 'html5',
  plugins: [
    'lists', 'link', 'paste', 'code',
    'searchreplace', 'preview', 'print', 'help',
  ],
  toolbar: 'undo redo | bold italic underline | bullist numlist outdent indent | link | code',
  height: '500',

  // SECURITY HARDENING
  verify_html: true,
  invalid_elements: 'script,iframe,object,embed,svg,noscript',
  extended_valid_elements: [
    'a[href|target|rel]',
    'strong,em,ul,ol,li,blockquote,code,pre,br',
    'p[class],span[class]',
    'img[src|alt|title|width|height|loading]'
  ].join(','),

  allow_unsafe_link_target: false,
  link_default_target: '_blank',
  link_rel_list: [
    { title: 'None', value: '' },
    { title: 'No opener', value: 'noopener' },
    { title: 'No opener, no referrer', value: 'noopener noreferrer' },
  ],

  paste_data_images: false,
  menubar: true,
  content_style: 'img{max-width:100%;height:auto} .mce-content-body{word-break:break-word}',
};

const menu = {
  file: { title: 'File', items: 'preview | print' },
  edit: { title: 'Edit', items: 'undo redo | cut copy paste | selectall | searchreplace' },
  view: { title: 'View', items: 'code' },
  insert: { title: 'Insert', items: 'link' },
  format: { title: 'Format', items: 'bold italic underline | removeformat' },
  // table: { title: 'Table', items: 'inserttable | cell row column | tableprops deletetable' },
  help: { title: 'Help', items: 'help' },
};

const config = { ...baseConfig, menu };
const tinyConfig = {
  getAPIKey() {
    // return appConfig.get('tiny.key');
    return 'edkx0nsecn0gk8pomar4t65k9zmp0va2xd3yxt2axmq8la7g';
  },
  getConfig() {
    return config;
  },
};

Object.freeze(tinyConfig);

export default tinyConfig;
